import { useRef, useState, useEffect } from "react";
import "./Register.css";
import { ReactComponent as Arrow } from "../assets/arrow.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../assets/Logo.svg";
import { auth, firestore } from "../firebase/firebaseConfig";
import { createUserWithEmailAndPassword } from "firebase/auth";
import {
  collection,
  query,
  where,
  getDocs,
  setDoc,
  doc,
} from "firebase/firestore";
import { useIsMobile } from "../hooks/useIsMobile";

function Register({ login }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const passwordRepeatRef = useRef(null);
  const [x, setX] = useState(0);
  const [currentRef, setCurrentRef] = useState(null);
  const [beingCreated, setBeingCreated] = useState(false);
  const [emailBeingChecked, setEmailBeingChecked] = useState(false);
  const [emailAlreadyInUse, setEmailAlreadyInUse] = useState(false);
  const [emailValid, setEmailValid] = useState(true);
  const [passwordTooShort, setPasswordTooShort] = useState(true);
  const [passwordUpperCaseMissing, setPasswordUpperCaseMissing] =
    useState(true);
  const [passwordLowerCaseMissing, setPasswordLowerCaseMissing] =
    useState(true);
  const [passwordNumbersMissing, setPasswordNumbersMissing] = useState(true);
  const [passwordsMatch, setPasswordsMatch] = useState(false);
  const [policyAgreed, setPolicyAgreed] = useState(false);
  const [policyAgreedError, setPolicyAgreedError] = useState(false);
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentRef)
      setTimeout(() => {
        currentRef.current.focus();
      }, 500);
  }, [x]);

  const checkIfEmailExists = async () => {
    setEmailBeingChecked(true);
    try {
      const q = query(
        collection(firestore, "users"),
        where("email", "==", email)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        setEmailBeingChecked(false);
        setEmailAlreadyInUse(true);
      } else {
        setEmailBeingChecked(false);
        setCurrentRef(passwordRef);
        setX(x + 1);
      }
    } catch (error) {
      setEmailBeingChecked(false);
    }
  };

  const checkEmail = () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (emailRegex.test(email)) {
      checkIfEmailExists();
    } else {
      setEmailValid(false);
    }
  };

  const checkPassword = (password) => {
    if (password.length >= 8) setPasswordTooShort(false);
    else setPasswordTooShort(true);

    if (/[A-Z]/.test(password)) setPasswordUpperCaseMissing(false);
    else setPasswordUpperCaseMissing(true);

    if (/[a-z]/.test(password)) setPasswordLowerCaseMissing(false);
    else setPasswordLowerCaseMissing(true);

    if (/\d/.test(password)) setPasswordNumbersMissing(false);
    else setPasswordNumbersMissing(true);
  };

  const submitPassword = () => {
    if (
      !passwordTooShort &&
      !passwordUpperCaseMissing &&
      !passwordLowerCaseMissing &&
      !passwordNumbersMissing
    ) {
      setCurrentRef(passwordRepeatRef);
      setX(x + 1);
    }
  };

  const signUp = async () => {
    setBeingCreated(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      await setDoc(doc(firestore, "users", user.uid), {
        email: user.email,
        name: "",
        createdAt: new Date(),
        language: "en",
        bookTokens: 0,
      });

      window.location.reload();

      setBeingCreated(false);
    } catch (error) {
      console.log(error.message);
      setBeingCreated(false);
    }
  };

  return (
    <div className="register">
      <p className="title">Create Your Account</p>
      <div
        style={{
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          top: "30%",
        }}
      >
        <span style={{ color: "white", fontSize: "20px" }}>or</span>
        <div
          className="start-free-trial"
          onClick={() => navigate("/freeTrial")}
        >
          Test Gliatech
        </div>
      </div>
      <div className="email" style={{ transform: `translateX(-${100 * x}%)` }}>
        <p>E-Mail</p>
        <div
          style={{
            height: isMobile ? "40px" : "50px",
            width: isMobile ? "90%" : "35%",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <Logo
            className="email-checking"
            style={{
              width: "10%",
              height: "100%",
              filter: "drop-shadow(0px 0px 10px white)",
              display: !emailBeingChecked && "none",
            }}
          ></Logo>
          <input
            type="text"
            inputMode="text"
            value={email}
            onChange={(e) => {
              setEmail(e.currentTarget.value);
              if (emailAlreadyInUse) setEmailAlreadyInUse(false);
              if (!emailValid) setEmailValid(true);
            }}
            onKeyDown={(e) => {
              if (!emailBeingChecked && e.key === "Enter") checkEmail();
            }}
            ref={emailRef}
          ></input>
          <div
            className="next-button"
            onClick={() => {
              if (!emailBeingChecked) checkEmail();
            }}
          >
            <Arrow style={{ height: "100%", width: "80%" }}></Arrow>
          </div>
        </div>
        <div
          className="error"
          style={{ display: !emailAlreadyInUse && "none" }}
        >
          • Email already in use!
        </div>
        <div className="error" style={{ display: emailValid && "none" }}>
          • Email invalid!
        </div>
        <p style={{ fontSize: isMobile ? "15px" : "25px" }}>
          Already have an account?{" "}
          <span
            className="log-in-link"
            onClick={() => {
              login();
            }}
          >
            Log in
          </span>
        </p>
      </div>
      <div
        className="password"
        style={{ transform: `translateX(-${100 * x}%)` }}
      >
        <p>Password</p>
        <div
          style={{
            height: isMobile ? "40px" : "50px",
            width: isMobile ? "90%" : "35%",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div
            className="previous-button"
            onClick={() => {
              setCurrentRef(emailRef);
              setX(x - 1);
            }}
          >
            <Arrow style={{ height: "100%", width: "80%" }}></Arrow>
          </div>
          <input
            value={password}
            onChange={(e) => {
              setPassword(e.currentTarget.value);
              checkPassword(e.currentTarget.value);
            }}
            type="password"
            inputMode="text"
            ref={passwordRef}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                submitPassword();
              } else if (e.key === "Backspace" && password.length === 0) {
                setCurrentRef(emailRef);
                setX(x - 1);
              }
            }}
          ></input>
          <div
            className="next-button"
            onClick={() => {
              submitPassword();
            }}
          >
            <Arrow style={{ height: "100%", width: "80%" }}></Arrow>
          </div>
        </div>
        <div className="error" style={{ display: !passwordTooShort && "none" }}>
          • Minimum of 8 Characters
        </div>
        <div
          className="error"
          style={{ display: !passwordUpperCaseMissing && "none" }}
        >
          • atleast one uppercase letter [A-Z]
        </div>
        <div
          className="error"
          style={{ display: !passwordLowerCaseMissing && "none" }}
        >
          • atleast one lowercase letter [a-z]
        </div>
        <div
          className="error"
          style={{ display: !passwordNumbersMissing && "none" }}
        >
          • atleast one Number [0-9]
        </div>
      </div>
      <div
        className="password-repeat"
        style={{ transform: `translateX(-${100 * x}%)` }}
      >
        <p>Repeat Password</p>
        <div
          style={{
            height: isMobile ? "40px" : "50px",
            width: isMobile ? "90%" : "35%",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div
            className="previous-button"
            onClick={() => {
              setCurrentRef(passwordRef);
              setX(x - 1);
            }}
          >
            <Arrow style={{ height: "100%", width: "80%" }}></Arrow>
          </div>
          <Logo
            className="email-checking"
            style={{
              width: "10%",
              height: "100%",
              filter: "drop-shadow(0px 0px 10px white)",
              display: !beingCreated && "none",
            }}
          ></Logo>
          <input
            value={passwordRepeat}
            onChange={(e) => {
              setPasswordRepeat(e.currentTarget.value);
              if (e.currentTarget.value === password) setPasswordsMatch(true);
              else setPasswordsMatch(false);
            }}
            type="password"
            inputMode="text"
            ref={passwordRepeatRef}
            onKeyDown={(e) => {
              if (e.key === "Enter" && passwordsMatch && !beingCreated) {
                if (!policyAgreed) {
                  setPolicyAgreedError(true);
                } else {
                  signUp();
                }
              } else if (e.key === "Backspace" && passwordRepeat.length === 0) {
                setCurrentRef(passwordRef);
                setX(x - 1);
              }
            }}
          ></input>
          <div
            className="next-button"
            onClick={() => {
              if (!policyAgreed) {
                setPolicyAgreedError(true);
              }
              if (passwordsMatch && !beingCreated && policyAgreed) {
                signUp();
              }
            }}
          >
            <Arrow style={{ height: "100%", width: "80%" }}></Arrow>
          </div>
        </div>
        <div className="error" style={{ display: passwordsMatch && "none" }}>
          • Passwords don't match!
        </div>
        <div
          className="agree-with-policy"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            color: "white",
            textShadow: "0px 0px 5px purple",
          }}
        >
          <div
            className="agree-policy-button"
            style={{
              height: "25px",
              width: "25px",
              border: policyAgreedError ? "2px red solid" : "2px white solid",
              borderRadius: "20px",
              backgroundColor: policyAgreed && "white",
              boxShadow: "0px 0px 5px purple",
            }}
            onClick={() => setPolicyAgreed(!policyAgreed)}
          ></div>
          I agree to the Terms & Conditions and the Privacy Policy.
        </div>
      </div>
      <div
        className="email-sent"
        style={{ transform: `translateX(-${100 * x}%)` }}
      >
        <p>
          You will recieve an email within the next minute to verify your
          account!
        </p>
      </div>
    </div>
  );
}

export default Register;
